document.addEventListener('DOMContentLoaded', function() {
    updateShippingBar();
    
    document.addEventListener('cart:refresh', updateShippingBar);
    document.addEventListener('cart:updated', updateShippingBar);
    document.addEventListener('cart:change', updateShippingBar);
    
    document.addEventListener('click', function(event) {
      const isCartButton = event.target.closest('button[name="add"]') || 
                          event.target.closest('.cart-item__quantity-wrapper button');
      
      if (isCartButton) {
        setTimeout(updateShippingBar, 3000);
      }
    });
  });
  
  function updateShippingBar() {
    slidercart(); //init slider carrousel
    const shippingThreshold = 5000; // 50.00 en cent
    let cartTotal = 0;
  
    if (window.cart && window.cart.total_price !== undefined) {
      cartTotal = window.cart.total_price;
    } else {
      const subtotalElement = document.querySelector('[data-cart-subtotal-price]');
      if (subtotalElement) {
        const subtotalText = subtotalElement.getAttribute('data-cart-subtotal-price') || '0';
        cartTotal = parseInt(subtotalText, 10);
      }
      
      if (cartTotal === 0) {
        // Intentar encontrar el valor en otro lugar
        const cartItems = document.querySelectorAll('.cart-item__price-wrapper');
        if (cartItems.length > 0) {
          cartItems.forEach(item => {
            const priceText = item.textContent.trim().replace(/[^0-9.]/g, '');
            if (priceText) {
              cartTotal += parseFloat(priceText) * 100; // Convertir a centavos
            }
          });
        }
      }
    }
    
    const percentage = Math.min((cartTotal / shippingThreshold) * 100, 100);
    setTimeout(() => {
      const progressBars = document.querySelectorAll('.shipping-progress-filled');
      if (progressBars && progressBars.length > 0) {
        progressBars.forEach(bar => {
          bar.style.width = `${percentage}%`;
        }); 
        
      }
    }, 100);
    
    const messageElement = document.querySelector('.shipping-message');
    if (messageElement) {
      if (cartTotal >= shippingThreshold) {
        messageElement.textContent = 'Your order qualifies for free shipping';
      } else {
        const remaining = Math.max(0, (shippingThreshold - cartTotal) / 100).toFixed(2);
        messageElement.textContent = `$${remaining} away from free shipping`;
      }
    }

  }

 
  document.addEventListener('DOMContentLoaded', function() {
   
  });

  function slidercart() {
    // Simple carousel implementation

    const container = document.querySelector('.embla-container');
    const slides = document.querySelectorAll('.embla-slide');
    const prevButton = document.querySelector('.announcement-nav-prev button');
    const nextButton = document.querySelector('.announcement-nav-next button');
    
    if (!container || slides.length <= 1) return;
    
    let currentIndex = 0;
    const totalSlides = slides.length;
    
    function goToSlide(index) {
      currentIndex = (index + totalSlides) % totalSlides;
      const offset = -currentIndex * 100;
      container.style.transform = `translateX(${offset}%)`;
    }
    
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        goToSlide(currentIndex - 1);
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        goToSlide(currentIndex + 1);
      });
    }
    
    // Auto-play functionality
    let autoplayInterval = setInterval(() => {
      goToSlide(currentIndex + 1);
    }, 4000);
    
    container.addEventListener('mouseenter', () => {
      clearInterval(autoplayInterval);
    });
    
    container.addEventListener('mouseleave', () => {
      autoplayInterval = setInterval(() => {
        goToSlide(currentIndex + 1);
      }, 4000);
    });
    
    // Initialize
    container.style.transition = 'transform 0.3s ease-in-out';
    slides.forEach(slide => {
      slide.style.flex = '0 0 100%';
    }); 
  }

  slidercart();
